import React from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { IMdLogDetail } from "../LogTypes";
import { useLogModel } from "../logModel";
import moment from "moment";
import { momentFormats } from "@src/utils/utils";

const columns: ColumnsType<IMdLogDetail> = [
    // {
    //     align: 'center',
    //     title: '序号',
    //     width: 60,
    //     render: (v, r, i) => i + 1
    // },
    {
        align: "center",
        title: '日志编码',
        width: 200,
        dataIndex: 'id',
    },
    {
        align: "center",
        title: '日志类型',
        width: 200,
        dataIndex: 'logType',
    },
    // {
    //     align: "center",
    //     title: '所属机构',
    //     width: 120,
    //     dataIndex: 'name',
    // },
    // {
    //     align: "center",
    //     title: '所属事业部',
    //     dataIndex: 'note',
    // },
    {
        align: "center",
        title: '用户姓名',
        width: 120,
        dataIndex: 'userName',
    },
    {
        align: "center",
        title: '账号',
        width: 120,
        dataIndex: 'userCode',
    },

    {
        align: "center",
        title: '操作时间',
        width: 120,
        dataIndex: 'loginTime',
        render: (value) => momentFormats(value)
    },
    {
        align: "center",
        title: '来源',
        width: 120,
        dataIndex: 'source',
    },
    {
        align: "center",
        title: 'IP',
        width: 120,
        dataIndex: 'ip',
    },
    {
        align: "center",
        title: '操作记录',
        width: 120,
        dataIndex: 'note',
    },
];

export function DataTable() {
    const {
        dataSource,
        pgCfg,
        loadData,
    } = useLogModel();


    return (
        <Table
            style={{ cursor: "pointer" }}
            // rowSelection={{
            //     type: "radio",
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: IMdLogDetail[]) => {
            //         setSelectedRowKeys(selectedRowKeys);
            //     },
            //     selectedRowKeys
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            scroll={{ x: 'max-content', y: "calc(100vh - 370px)" }}

        // onRow={record => {
        //     return {
        //         onClick: event => {
        //             if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
        //                 setSelectedRowKeys([]);
        //             } else {
        //                 setSelectedRowKeys([record.key]);
        //             }
        //         },
        //     };
        // }}
        />
    )
}


